export class EmailTemplate {
  idEmailTemplate: number;
  name: string;
  orphan: boolean;

  constructor(
    idEmailTemplate: number,
    name: string,
    orphan: boolean,
  ) {
    this.idEmailTemplate = idEmailTemplate;
    this.name = name;
    this.orphan = orphan;
  }

  static fromRaw(raw: any): EmailTemplate {
    return new EmailTemplate(
      Number(raw.idEmailTemplate),
      String(raw.name),
      Boolean(raw.orphan),
    );
  }

  clone(): EmailTemplate {
    return new EmailTemplate(
      this.idEmailTemplate,
      this.name,
      this.orphan,
    );
  }

  toPayload(): any {
    return {
      idEmailTemplate: this.idEmailTemplate,
      name: this.name,
      orphan: this.orphan,
    };
  }
}
